import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ParentLoginComponent } from './parent-login/parent-login.component';

const routes: Routes = [
  { path: 'parent', component: ParentLoginComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeleteRoutingModule { }
